/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Due_Date_HeaderInputs */



/**
* | output |
* | --- |
* | "Due Date" |
*
* @param {Explorer_Table_Due_Date_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_due_date_header = /** @type {((inputs?: Explorer_Table_Due_Date_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Due_Date_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "de") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "it") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "es") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Due Date")
	return /** @type {LocalizedString} */ ("Due Date")
});